import { Checkbox, Collapse, Input, Row, Typography } from "antd";
import { MceEditor } from "shared/components/tinymce/mce-editor";
import { ContentText, Title } from "shared/constants/define-localization";
import { CoreResource, t } from "shared/plugins/localization";
import { cleanUnicode } from "shared/plugins/string-helper";

import { StaticPageModel } from "states/static-page/static-page.models";

export interface IStaticPageInformationTabProps {
  model: StaticPageModel;
  onChange: (newModel: StaticPageModel) => void;
  isUpdateMode: boolean;
}
export function StaticPageInformationTab(
  props: IStaticPageInformationTabProps
) {
  const { model, onChange, isUpdateMode } = props;
  return (
    <div>
      <Collapse defaultActiveKey={["1"]} className="mb-4">
        <Collapse.Panel key="1" header="Thông tin">
          <Row gutter={[16, 16]}>
            <Input.Group className="mb-4">
              <Typography.Text>Tên trang: </Typography.Text>
              <Input
                value={model.title}
                onChange={(e) => {
                  onChange({
                    ...model,
                    title: e.target.value,
                    seoFields: {
                      ...model.seoFields,
                      metaTitle: e.target.value,
                    },
                    slug: cleanUnicode(e.target.value),
                  });
                }}
                placeholder={t(CoreResource, Title)}
              ></Input>
            </Input.Group>
            <Input.Group className="mb-4">
              <Typography.Text>
                Nội dung:
              </Typography.Text>
              <MceEditor
                pageContent={model.pageContent}
                onChange={(e) => {
                  onChange({ ...model, pageContent: e });
                }}
              ></MceEditor>
            </Input.Group>
            <Input.Group className="mb-4">
              <Checkbox
                checked={model.isCustomizePage}
                onChange={(e) => {
                  onChange({ ...model, isCustomizePage: e.target.checked });
                }}
              >
               Trang tùy chỉnh
              </Checkbox>
            </Input.Group>
          </Row>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}
